// @generated by protobuf-ts 2.9.4 with parameter generate_dependencies,optimize_code_size
// @generated from protobuf file "backend/v1/user.proto" (package "backend.v1", syntax proto3)
// tslint:disable
import { MessageType } from "@protobuf-ts/runtime";
import { Date } from "../../core/v1/date";
/**
 * @generated from protobuf message backend.v1.User
 */
export interface User {
    /**
     * @generated from protobuf field: string uuid = 1;
     */
    uuid: string;
    /**
     * @generated from protobuf field: string email = 2;
     */
    email: string;
    /**
     * @generated from protobuf field: string timezone = 5;
     */
    timezone: string;
    /**
     * @generated from protobuf field: core.v1.Date current_date = 6;
     */
    currentDate?: Date; // the user's "today" (a dev override when set, else their timezone's date)
    /**
     * @generated from protobuf field: bool is_admin = 7;
     */
    isAdmin: boolean;
    /**
     * @generated from protobuf field: backend.v1.ProductKeyState product_key_state = 8;
     */
    productKeyState: ProductKeyState;
    /**
     * @generated from protobuf field: bool email_verified = 9;
     */
    emailVerified: boolean;
    /**
     * @generated from protobuf field: string company_name = 10;
     */
    companyName: string;
    /**
     * @generated from protobuf field: bool has_family = 11;
     */
    hasFamily: boolean; // false until onboarding is saved
    /**
     * @generated from protobuf field: bool is_super_admin = 12;
     */
    isSuperAdmin: boolean;
}
/**
 * @generated from protobuf enum backend.v1.ProductKeyState
 */
export enum ProductKeyState {
    /**
     * @generated from protobuf enum value: PRODUCT_KEY_STATE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: PRODUCT_KEY_STATE_UNREGISTERED = 1;
     */
    UNREGISTERED = 1,
    /**
     * @generated from protobuf enum value: PRODUCT_KEY_STATE_ACTIVE = 2;
     */
    ACTIVE = 2,
    /**
     * @generated from protobuf enum value: PRODUCT_KEY_STATE_EXPIRED = 3;
     */
    EXPIRED = 3
}
// @generated message type with reflection information, may provide speed optimized methods
class User$Type extends MessageType<User> {
    constructor() {
        super("backend.v1.User", [
            { no: 1, name: "uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "timezone", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "current_date", kind: "message", T: () => Date },
            { no: 7, name: "is_admin", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "product_key_state", kind: "enum", T: () => ["backend.v1.ProductKeyState", ProductKeyState, "PRODUCT_KEY_STATE_"] },
            { no: 9, name: "email_verified", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 10, name: "company_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "has_family", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 12, name: "is_super_admin", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message backend.v1.User
 */
export const User = new User$Type();
